import { Component, HostBinding, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LocationService } from "./location.service";
import { ShareService } from "../../../../shared/service/share.service";
import { messages } from "../../../../shared/model/Responsemessages";
import { StorageService } from "../../../../Service/storage.service";
import { AuthService } from "../../../../core/auth/auth.service";

@Component({
  selector: "kt-location",
  templateUrl: "./location.component.html",
  styleUrls: ["./location.component.scss"],
  standalone: false
})
export class LocationComponent implements OnInit {
  @HostBinding("class") classes = "";
  locationList: any;
  active: boolean;
  currentLocation: any;
  @ViewChild("myDrop", { static: true }) myDrop: any;
  currentLocationList: any;
  searchTerm: string = '';
  filteredLocationList: any[] = [];

  constructor(
    private router: Router,
    private locationservice: LocationService,
    public shared: ShareService,
    private readonly storageService: StorageService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.searchTerm = '';

    if (!this.authService.isInOnboarding()) {
      this.getAllLocation().then(() => {
        this.updateCurrentLocation();
      });
    }

    this.router.events.subscribe(() => {
      let AspNetRole = this.storageService.getItem("AspNetRole");
      let routingPage = this.storageService.getItem("routingPage");
      let isAdmin = AspNetRole?.includes("Admin");

      if ((routingPage !== "Dashboard" && routingPage !== "Reports") && isAdmin) {
        if (this.locationList) {
          if (this.currentLocation === 'All' && !window.location.hash.includes("Dashboard")) {
            this.setLocation(this.locationList[0]?.Name);
          }
          this.locationList = this.locationList.filter((key) => key.Id !== 0);
        }
      }
    });
  }

  setLocation(loc: string, isFromDropDown?: boolean) {
    if (!this.locationList || this.locationList.length === 0) {
      setTimeout(() => this.setLocation(loc), 300);
      return;
    }

    const locationItem = this.locationList.find(x => x.Name === loc);
    const storedLocation = JSON.parse(this.storageService.getItem("Location"));
    const lastReloadedLocation = sessionStorage.getItem("LastReloadedLocation");

    if (locationItem && (!storedLocation || storedLocation.name !== loc)) {
      this.active = true;
      this.currentLocation = loc;
      this.storageService.setItem("Location", JSON.stringify(locationItem));
      this.shared.locations.next(locationItem.Id);
      this.currentLocationList = JSON.stringify(this.locationList);

      if (loc !== 'All') {
        let param = {
          Id: 0,
          UserId: this.storageService.getItem("userId"),
          LocationId: locationItem.Id,
          CompanyId: this.storageService.getItem("companyId"),
          isFirst: !isFromDropDown || isFromDropDown === undefined
        };
        this.locationservice.setasDefault(param).subscribe((res) => {
          if (res["ResponseCode"] !== 200) {
            this.shared.showToast(messages["ResponseCode"], "Error");
          }
        });
      }
      this.shared.setLocationslot(this.currentLocationList);

      // Prevent unnecessary reloading: Only reload if location has changed
      if (lastReloadedLocation !== loc) {
        if (isFromDropDown) {
          window.location.reload();
        }
        sessionStorage.setItem("LastReloadedLocation", loc);
      }
    }
  }

  getAllLocation(): Promise<void> {
    return new Promise((resolve) => {
      this.shared.getAllLocation().then((response) => {
        if (response["Data"]) {
          this.locationList = response["Data"];

          let AspNetRole = this.storageService.getItem("AspNetRole");
          let routingPage = this.storageService.getItem("routingPage");
          if (AspNetRole?.includes("Admin") && (routingPage === "Dashboard" || routingPage === "Reports")) {
            this.locationList.push({ Id: 0, Name: 'All' });
          }

          this.filteredLocationList = [...this.locationList];
        } else {
          this.locationList = [];
          this.filteredLocationList = [];
          this.currentLocation = "";
        }
        resolve();
      });
    });
  }

  updateCurrentLocation() {
    const storedLocation = JSON.parse(this.storageService.getItem("Location"));
    let locationItem = this.locationList?.find(l => l.Id == (storedLocation?.id ?? storedLocation?.Id));
    this.setLocation(locationItem?.Name);
    this.currentLocation = locationItem?.Name;
  }

  filterLocations() {
    this.filteredLocationList = this.locationList.filter(location =>
      location.Name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }
}

